<template>
  <div class="wrapper">
    <div class="main-slides h-50vh" style="background: url(img/key_features.jpg); background-size: cover;">
      <div class="page-header h-50vh">
        <div class="container">
          <div class="row align-items-center text-center justify-content-center">
            <div class="col-lg-9 col-12" v-animate-onscroll="{down: 'animated fadeOutDown', up: 'animated fadeInDown'}">
              <h1 class="display-2 mt-6 text-light">Mandatory Public Disclosure</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section py-5">
      <div class="container">

        <div v-if="loading" class="text-center py-5">
          <i class="fa fa-spinner fa-spin fa-2x text-muted"></i>
          <p class="mt-3 text-muted">Loading documents…</p>
        </div>

        <div v-else-if="error" class="text-center py-5">
          <i class="fa fa-exclamation-circle fa-2x text-danger"></i>
          <p class="mt-3 text-muted">{{ error }}</p>
        </div>

        <div v-else>
          <div class="row mb-4">
            <div class="col">
              <h4 class="text-alpine mb-0">Documents <span class="badge badge-secondary ml-2">{{ files.length }}</span></h4>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-12 mb-4" v-for="file in files" :key="file.id">
              <div class="card card-raised shadow-sm h-100">
                <div class="card-body d-flex align-items-start">
                  <div class="file-icon mr-3 mt-1">
                    <i class="fa fa-file-pdf-o fa-2x text-danger"></i>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="mb-1 font-weight-bold">{{ file.name }}</h6>
                    <p class="text-muted small mb-2">
                      <span v-if="file.size">{{ formatSize(file.size) }}</span>
                    </p>
                    <a
                      :href="'https://drive.google.com/file/d/' + file.id + '/view'"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="btn btn-sm btn-outline-danger"
                    >
                      <i class="fa fa-eye mr-1"></i> View
                    </a>
                    <a
                      :href="'https://drive.google.com/uc?export=download&id=' + file.id"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="btn btn-sm btn-outline-secondary ml-2"
                    >
                      <i class="fa fa-download mr-1"></i> Download
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const FOLDER_ID = process.env.VUE_APP_GDRIVE_FOLDER_ID;
const API_KEY = process.env.VUE_APP_GDRIVE_API_KEY;

export default {
  name: "MandatoryPublicDisclosure",
  bodyClass: "mandatory-public-disclosure",
  data() {
    return {
      files: [],
      loading: true,
      error: null,
    };
  },
  mounted() {
    this.fetchFiles();
  },
  methods: {
    async fetchFiles() {
      try {
        const response = await axios.get("https://www.googleapis.com/drive/v3/files", {
          params: {
            q: `'${FOLDER_ID}' in parents and trashed = false`,
            key: API_KEY,
            fields: "files(id,name,mimeType,size,modifiedTime)",
            orderBy: "name",
          },
        });
        this.files = response.data.files || [];
      } catch (e) {
        this.error = "Unable to load documents. Please try again later.";
      } finally {
        this.loading = false;
      }
    },
    formatSize(bytes) {
      const kb = parseInt(bytes) / 1024;
      if (kb < 1024) return `${Math.round(kb)} KB`;
      return `${(kb / 1024).toFixed(1)} MB`;
    },
    formatDate(iso) {
      if (!iso) return "";
      return new Date(iso).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
  },
};
</script>

<style scoped>
.h-50vh {
  height: 50vh !important;
  min-height: 50vh !important;
}
.file-icon {
  flex-shrink: 0;
}
.card {
  border-radius: 0.75rem;
  transition: box-shadow 0.2s ease;
}
.card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
}
</style>
